import styled from 'styled-components';
import { CUSTOM_TYPOGRAPHY_CSS, type CustomTypographyProps } from './custom-typography';

export const P14 = styled.p<CustomTypographyProps>`
  font-size: 14px;
  line-height: 1.5;
  ${CUSTOM_TYPOGRAPHY_CSS};
`;
